import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import HeaderLayout from '../../../../components/Layout/Header/HeaderLayout';
import SimulatorInvestmentPortfolio from '../../../../components/simulator/SimulatorInvestmentPortfolio';
import Spinner from '../../../../components/Spinner';
import ModalErrorFetch from '../../../../components/UI/ModalErrorFetch';
import { useCashBalance } from '../../../../context/CashBalanceContext';
import { InvestmentContext } from '../../../../context/InvestmentContext';
import useModal from '../../../../hooks/custom/useModal';
import { useGetModelsPortfolioById } from '../../../../hooks/useGetModelsPortfolioById';
import { portfolioNameAndDetails } from '../../../../utils/portfolioNameAndDetails';
import { onRefresh } from '../../../../utils/refreshPage';

const InvestmentPortfolio = () => {
  const { id } = useParams();
  const user = useSelector(state => state.auth.user);
  const userRisk = user?.['custom:profile'] ? user['custom:profile'].toLowerCase() : '';
  const { isShowing, toggle } = useModal();

  const { formData, resetFormData } = useContext(InvestmentContext);

  const {
    balance: balanceData,
    loading: loadingBalance,
    error: errorBalance,
    refetch,
  } = useCashBalance();

  const {
    data: dataPortolioById,
    loading: loadingDataPortolioById,
    error: errorDataPortolioById,
  } = useGetModelsPortfolioById({
    modelId: id,
  });

  if (loadingDataPortolioById) {
    return <Spinner />;
  }

  const dataPortfolioSimulationById = dataPortolioById?.getModelById || [];

  const dataChart = dataPortfolioSimulationById[0] || {};

  const profilePortfolio = dataChart?.code;

  const typePayment = dataChart?.currency;

  const portfolioName = dataChart?.name || '';
  const result = portfolioName ? portfolioNameAndDetails(portfolioName) : {};
  const { fileAsComplete = portfolioName || 'Portafolio' } = result;

  const userRiskCondition =
    profilePortfolio
      ?.replace(/\bCLP\b\s*/g, '')
      .trim()
      .toLowerCase() === userRisk;

  if (errorBalance || errorDataPortolioById) {
    return (
      <ModalErrorFetch
        message='Lo sentimos, algo no salio bien acá....'
        error={errorBalance || errorDataPortolioById}
        open={!isShowing}
        onClose={toggle}
        refresh={onRefresh}
      />
    );
  }

  if (loadingBalance) {
    return <Spinner />;
  }

  return (
    <>
      <HeaderLayout type='product' mode='portfolio' dataChart={dataChart} />

      <SimulatorInvestmentPortfolio
        dataChart={dataChart}
        formData={formData}
        portfolioName={fileAsComplete}
        typePayment={typePayment}
        balanceData={balanceData}
        userRisk={userRisk}
        userRiskCondition={userRiskCondition}
        profilePortfolio={profilePortfolio}
        refetch={refetch}
        resetFormData={resetFormData}
      />
    </>
  );
};

export default InvestmentPortfolio;
